// extracted by mini-css-extract-plugin
export default {"ProposalQuotesLoader":"proposalQuotes_ProposalQuotesLoader__tg191"};